import {makeObservable, observable} from 'mobx'
import BaseModel from './BaseModel'

export default class AttendanceQuery extends BaseModel{
  constructor(store) {
    super(store);
    makeObservable(this, {
      page_number: observable,
      page_count: observable,
      page_size: observable,
      count: observable,
      team_id: observable,
      date_from: observable,
      date_to: observable,
      company_user_id: observable
    })
  }
  
  page_number = 1;
  page_count = 1;
  page_size = 10;
  count = 0;
  team_id = 0;
  date_from = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  date_to = new Date();
  company_user_id = 0;
}